import React, { useEffect } from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormInput from 'common/components/form/ReactHookFormInput';
import ShowErrors from 'common/components/ShowErrors';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validate'; // Assuming validate.js is in the same directory

const InstallerForm = ({
    errors,
    handleClickCloseForm,
    initialValues,
    installerId,
    isSaving,
    onSuccess,
    save,
}) => {
    const { t } = useTranslation();
    const disabled = false;

    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const handleOnClickSubmit = (values) =>
        save({ ...values, installerId: installerId }, onSuccess);

    return (
        <Stack component="form" onSubmit={handleSubmit(handleOnClickSubmit)}>
            <ReactHookFormInput
                control={control}
                disabled={disabled}
                label={t('Legal representative')}
                name="legal_representative"
                placeholder={t('Legal representative')}
            />

            <ReactHookFormInput
                control={control}
                disabled={disabled}
                label={t('Phone')}
                name="phone"
                placeholder={t('Phone')}
            />

            <ReactHookFormInput
                control={control}
                disabled={disabled}
                label={t('Email')}
                name="email"
                placeholder={t('Email')}
            />

            <ReactHookFormInput
                control={control}
                disabled={disabled}
                label={t('City')}
                name="city"
                placeholder={t('City')}
            />

            <ShowErrors errors={errors} />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'end' }}>
                <Button
                    color="secondary"
                    onClick={handleClickCloseForm}
                    variant="text"
                >
                    {t('Cancel')}
                </Button>

                {!disabled && (
                    <Button disabled={isSaving} type="submit">
                        {t('Save')}
                    </Button>
                )}
            </Box>
        </Stack>
    );
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValuesInstallerDataForm,
    isSaving: selectors.getUpdateInstallerIsSaving,
});

const mapDispatchToProps = (dispatch) => ({
    save: (values, onSuccess) =>
        dispatch(actions.updateInstallerData(values, onSuccess)),
});

InstallerForm.propTypes = {
    errors: PropTypes.object,
    handleClickCloseForm: PropTypes.func,
    initialValues: PropTypes.object,
    installerId: PropTypes.string,
    isSaving: PropTypes.bool,
    onSuccess: PropTypes.func,
    save: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(InstallerForm);
